import asyncBuilder from 'utilities/actions';
import repository from 'client/repository';
import { clear as clearLocation } from 'areas/location/actions';
import { clear as clearSwipes } from 'areas/swipes/actions';
import { updateToken } from 'workers/mediator';

const signOutAction = asyncBuilder(
    'SIGN_OUT',
    (qrCode) => repository.auth.signout(qrCode),
    undefined,
    (dispatch) => {
        dispatch(clearLocation());
        dispatch(clearSwipes());
        updateToken(null);
    }
);

export default signOutAction;
